import { forOwn } from "lodash";
import xml from "xmlbuilder";
import saveSync from "save-file";

export class XmlWriter {
  private root: xml.XMLElement;
  constructor(
    rootName: string,
    rootAttrs?: { [name: string]: string | number }
  ) {
    this.root = xml.create(rootName, { encoding: "utf-8" });
    if (rootAttrs) {
      forOwn(rootAttrs, (value, name) => {
        this.root.att(name, value);
      });
    }
  }

  public element(
    name: string,
    content?: string | object,
    attrs?: { [name: string]: string | number }
  ) {
    content = content === undefined ? "" : content;
    const el = this.root.ele({ [name]: content });
    if (attrs) {
      forOwn(attrs, (value, name) => {
        el.att(name, value);
      });
    }
  }

  public toString(): string {
    return this.root.end({ pretty: true });
  }

  public saveAs(filename: string): Promise<void> {
    return new Promise<void>((res, rej) => {
      try {
        saveSync(
          new Blob([this.toString()], { type: "text/plain;charset=utf-8" }),
          filename
        );
        res();
      } catch (err) {
        rej(err);
      }
    });
  }
}
